import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useRemoveUser = () => {
  const mutation = useMutation((sheetId) => {
    return axiosClient.post(`/Sheet/RemoveUserSheetCache?sheetId=${sheetId}`);
  });
  return mutation;
};

export default useRemoveUser;